import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const Definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            backgroundImage: anyImageOpResult,
            foregroundImage: anyImageOpResult,
            maskImage: anyImageOpResult,
            wrapAround: z.boolean().optional().default(false),
            testParam1: z.number().optional(),
            testParam2: z.number().optional(),
        }),
    },
}
